export default {
  title: 'Extratos Mensais',
  list: {
    empty_list: {
      title: 'Ainda não há extratos mensais.',
    },
    fields: {
      month: 'Mês',
      stripe_service_invoice_url: 'Fatura Stripe',
      paypal_service_invoice_url: 'Fatura PayPal',
    },
    button: {
      title: 'Exportar',
    },
  },
  export_modal: {
    title: 'Exportar',
    start_date: {
      title: 'Data de início',
      placeholder: 'data',
    },
    end_date: {
      title: 'Data de fim',
      placeholder: 'data',
    },
    button: {
      export: 'Exportar',
      close: 'Fechar',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
